import React, {useContext, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {useNavigate} from "react-router-dom"
import {AuthContext} from '../context/AuthContext'
import {
    addUniqueItemToArr,
    checkName, getAuthHeader, getLocalStorageItem,
    getMoneyMonthDetailPath,
    objectLang,
    setErrorWindow,
    setGlobalMoneyObject, setLocalStorageItem
} from "../functions"
import {LoaderClass} from "../elements/LoaderClass"
import config from "../config.json"
import {AddCashToClass} from "../elements/AddCashToClass"
import {ModalWin} from "../elements/ModalWin"

export const AddCashTo = (purpose) => {
    setLocalStorageItem('page', 'AddCashTo')
    const lang = objectLang().language
    const l = lang.lang
    const navigate = useNavigate()
    const auth = useContext(AuthContext)
    const {loading, request} = useHttp()
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [show, setShow] = useState(true)
    const [inputID, setInputID] = useState('purchase-input-date')
    const [view, setView] = useState(true)

    const globalMoneyObject = getLocalStorageItem('global-money-object')
    let money = {}
    money['years'] = {}
    for (const i in Object.keys(globalMoneyObject)) {
        if (Number(Object.keys(globalMoneyObject)[i] > 0)) {
            money['years'][Object.keys(globalMoneyObject)[i]] = globalMoneyObject[Object.keys(globalMoneyObject)[i]]
        }
    }
    const cards = globalMoneyObject['general']['settings']['cards']

    const arrAllNames = [], arrUniqueNames = []
    const years = money['years']
    for (const yearName in years) {
        const months = years[yearName]
        for (const month in months) {
            const purpose = months[month]
            for (const e in purpose) {
                const element = purpose[e]
                if (element['income']) {
                    for (const elemInc in element['income']) {
                        arrAllNames.push(elemInc.split(';')[1])
                    }
                }
                if (element['expensePurchase']) {
                    for (const elemPur in element['expensePurchase']) {
                        arrAllNames.push(elemPur.split(';')[1])
                    }
                }
            }
        }
    }

    for (const i in arrAllNames) {
        addUniqueItemToArr(arrUniqueNames, arrAllNames[i])
    }

    let oldNamesArr = []

    const urlParams = new URLSearchParams(window.location.search)
    let urlType = 'purchase'
    if (urlParams.get('type')) {
        urlType = urlParams.get('type')
    }

    let incExp = lang.body.moneyPage.main.expenses, types = {income: false, expense: false, credit: false, perPayment: false, purchase: false}
    if (purpose.purpose === 'income') {
        types.income = true
        incExp = lang.body.moneyPage.main.income
    } else if (purpose.purpose === 'expense' && urlType === 'credit') {
        types.credit = true
        types.expense = true
        incExp = lang.body.moneyPage.main.credit
    } else if (purpose.purpose === 'expense' && urlType === 'per-payment') {
        types.perPayment = true
        types.expense = true
        incExp = lang.body.moneyPage.main.perPayment
    } else if (purpose.purpose === 'expense' && urlType === 'purchase') {
        types.purchase = true
        types.expense = true
        incExp = lang.body.moneyPage.main.purchase
    }

    const data = {
        title: `${lang.body.moneyPage.main.add} ${incExp}`,
        desc: lang.body.cardBankPage.descAdd,
        btnOKColor: 'success',
        btnCancelColor: 'secondary',
        btnOK: lang.body.cardBankPage.btnCreate,
        btnCancel: lang.body.cardBankPage.btnCancel,
        date: urlParams.get('date')
    }

    if (types.perPayment) {
        const arrDel = []
        for (const key in cards) {
            if (cards[key][4] === 'current-day') {
                arrDel.push(key)
            }
        }
        for (let i = 0; i < arrDel.length; i++) {
            cards.splice(i, 1)
        }
    }

    if (purpose.purpose === 'expense' && urlType === 'credit') {
        setDataModal(setErrorWindow(
            '',
            '',
            lang.body.moneyPage.main.expenseInactive,
            '',
            `replaceTo /${l}/money/main`
        ))
        setAllowed(false)
    }

    const closeHandler = () => {
        setShow(false)
    }

    const changeNameHandler = (e) => {
        oldNamesArr = []
        const letter = e.target.value.toLowerCase()
        for (const i in arrUniqueNames) {
            if (arrUniqueNames[i].toLowerCase().includes(letter) && letter) {
                if (oldNamesArr.length < 5) {
                    oldNamesArr.push(arrUniqueNames[i])
                }
            }
        }

        const input = document.querySelector('#input-name')

        const elem_ul = document.querySelector('#elem-ul')
        if (elem_ul) {
            elem_ul.remove()
        }

        const ul = document.createElement('ul')
        ul.className = 'dropdown-menu'
        ul.id = 'elem-ul'
        if (oldNamesArr.length < 1) {
            ul.classList.remove('show')
        } else {
            ul.classList.add('show')
        }
        for (const i in oldNamesArr) {
            const e_a = document.createElement('a')
            const e_li = document.createElement('li')
            e_li.className = 'mt-1 text-decoration-point bg-light'
            e_a.innerHTML = oldNamesArr[i]
            e_a.className = 'dropdown-item'
            e_a.href = '#'
            e_a.onclick = () => {
                document.querySelector('#input-name').value = e_a.innerHTML
                document.querySelector('#elem-ul').remove()

            }
            e_li.append(e_a)
            ul.append(e_li)
        }
        input.after(ul)
    }

    const sendHandler = async (bodyObject) => {
        setView(false)
        if (purpose.purpose === 'expense') {
            if (!bodyObject['cardId'] ||
                !bodyObject['name'] ||
                !bodyObject['means'] ||
                !bodyObject['purchaseDate'] ||
                !bodyObject['paymentDate'] ||
                !bodyObject['value'] ||
                !bodyObject['currency'] ||
                !bodyObject['count']) {

                setAllowed(false)
                setDataModal(setErrorWindow(
                    '',
                    591,
                    '',
                    '',
                    `replaceTo /${l}/money/add-${purpose.purpose}?type=${urlParams.get('type')}`
                ))
                return
            }
        }
        if (purpose.purpose === 'income') {

            if (!bodyObject['name'] ||
                !bodyObject['paymentDate'] ||
                !bodyObject['value']) {

                setAllowed(false)
                setDataModal(setErrorWindow(
                    '',
                    591,
                    '',
                    '',
                    `replaceTo /${l}/money/add-${purpose.purpose}`
                ))
                return
            }
        }

        if (!checkName(bodyObject['name'])) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                '',
                594,
                '',
                '',
                `replaceTo /${l}/money/add-${purpose.purpose}`
            ))
            return
        }

        let type = ''
        if (purpose.purpose === 'expense') {
            type = `?type=${urlParams.get('type')}`
        }
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/money/send/${purpose.purpose}${type}`,
                'POST',
                bodyObject,
                {
                    Authorization: getAuthHeader(auth)
                })
            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                setGlobalMoneyObject(data['money'])
                setTimeout(() => {
                    setView(true)
                }, 1000)
                navigate(getMoneyMonthDetailPath())
            }

        } catch (e) {
            navigate(`/${l}/money/main`)
        }
    }

    const viewCalendar = (inputId) => {
        setInputID(inputId)
        const calendar = document.querySelector('.calendar')
        if (calendar.style.display === 'block') {
            calendar.style.display = 'none'
        } else {
            calendar.style.display = 'block'
        }
    }

    if (getLocalStorageItem('isNewMoney')) {
        navigate(`/${l}/money/add-card`) // Переходим на страницу "Добавить карту"
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>
        )
    }

    if (view) {
        return (
            <>
                <AddCashToClass
                    show={show}
                    closeHandler={closeHandler}
                    data={data}
                    sendHandler={sendHandler}
                    purpose={purpose}
                    cards={cards}
                    types={types}
                    changeNameHandler={changeNameHandler}
                    viewCalendar={viewCalendar}
                    inputID={inputID}
                />
            </>
        )
    } else {
        return <LoaderClass/>
    }
}